import { ApiShopperLandingPage } from '@storefronts/common-types'
import Script from 'next/script'

export const RedditPixel: React.FC<{ landingPage: ApiShopperLandingPage }> = ({
    landingPage,
}) => {
    if (!landingPage.integrations.redditPixelId) return null

    return (
        <Script id="reddit-pixel" strategy="afterInteractive">
            {`
                !function(w,d){
                    if(!w.rdt){
                        var p=w.rdt=function(){
                            p.sendEvent ? p.sendEvent.apply(p,arguments) : p.callQueue.push(arguments)
                        };
                        p.callQueue=[];
                        var t=d.createElement("script");
                        t.src="https://www.redditstatic.com/ads/pixel.js";
                        t.async=!0;
                        var s=d.getElementsByTagName("script")[0];
                        s.parentNode.insertBefore(t,s);
                    }
                }(window,document);
                rdt('init','${landingPage.integrations.redditPixelId}');
                rdt('track','PageVisit');
            `}
        </Script>
    )
}
